
import React from 'react';
import Header from './Header';
import './Publications.css';
import publications from './publicationsData';

const PublicationsByTopic: React.FC = () => {
    
    //order the unique topics from the publications
    // Topics and their order follow hongyangzhang.com/pub_by_topic.html. A topic
    // missing from this list is filtered out of the page entirely.
    const topicOrder = [
        'Matrix recovery',
        'Neural net Hessian',
        'Multitask learning',
        'Language models',
        'Robustness and data augmentation',
        'Large-scale networks',
        'Incentives and cooperative games',
        'Others',
    ];
    //get the unique topics from the publications and sort them based on the predefined order
    const uniqueTopics = [...new Set(publications.map((pub) => pub.topic))]
        .filter((topic) => topicOrder.includes(topic))
        .sort((a, b) => topicOrder.indexOf(a) - topicOrder.indexOf(b));

    return (
        <div>
            <Header />
            <div className="publications-container">
                <div className="publications-list">
                    {/* Group by topic */}
                    {uniqueTopics.map((topic) => (
                        <div key={topic}>
                            <h2>{topic}</h2>
                            <ul>
                                {publications
                                    .filter((publication) => publication.topic === topic)
                                    .map((publication, index) => (
                                        <li key={index}>
                                            <h3><a href={publication.link}>{publication.title}</a></h3>
                                            <p><i>{publication.authors}</i></p>
                                            <p>{publication.publishingSite} ({publication.date})</p>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PublicationsByTopic;
